import { useState, useEffect, useContext } from "react";
import "./Login.css";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router-dom";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import TextInput from "../../Common/Textfield/Textfield";
import Button from "../../Common/Button/Button";
import backgroundImage from "../../Assets/Images/forgotpassword.svg";
import sliderDots from "../../Assets/Images/slider-dots.png";
import vybogTalLogo from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTalDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import SignUpIcon from "../../Assets/Images/Sign_Up_Icon.svg";
import { post } from "../../helper/Api_helper";
import { DynamicContext } from "../../Context/DynamicContext";
import { USER_FORGOT_PASSWORD, VYLABS_BASE_URL } from "../../helper/url_helper";
import { TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";

function ForgotPassword() {
  const { isDarkMode } = useContext(DynamicContext);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 768);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleForgotPassword = async (values) => {
    setIsLoading(true);
    try {
      await post(
        VYLABS_BASE_URL,
        USER_FORGOT_PASSWORD,
        {
          email: values.forgotPasswordEmail,
        },
        { 
          _skipAuth: true, 
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        }
      );

      Toast("success", "Reset code sent to your email.");
      navigate("/reset-password", {
        state: { email: values.forgotPasswordEmail },
      });
    } catch (error) {
      const responseData = error.response?.data;
      const remainingSeconds =
        responseData?.remaining_seconds ??
        responseData?.remainingSeconds ??
        responseData?.seconds_remaining ??
        responseData?.seconds;
      const message =
        responseData?.message ||
        responseData?.error ||
        (typeof responseData === "string" ? responseData : "");

      Toast(
        "error",
        message ||
          (remainingSeconds
            ? `Please try again in ${remainingSeconds} seconds.`
            : "Unable to send reset code. Please try again."),
      );
    } finally {
      setIsLoading(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      forgotPasswordEmail: "",
    },
    validationSchema: Yup.object({
      forgotPasswordEmail: Yup.string()
        .email("Invalid email address")
        .required("Please enter your email."),
    }),
    onSubmit: handleForgotPassword,
  });

  const handleLogin = () => {
    navigate("/");
  };
  return (
    <div className="login-page">
      <div className="login-main-container">
        <div className="login-header">
          <img
            alt="vylogo"
            src={isDarkMode ? vybogTalDarkLogo : vybogTalLogo}
            className="vylogo"
          />
        </div>
        <div className="login-container">
          <div className="forgot-content">
            <h1 className="forgot-title">Forgot Password?</h1>
            <p className="forgot-subtitle">
              Enter your registered email address. we will send a verification
              code to reset your password.
            </p>
          </div>
          <div className="input-container">
            <TextInput
              type="text"
              label={"Email"}
              placeholder="you@example.com"
              labelStyle={{ fontWeight: 500 }}
              name="forgotPasswordEmail"
              value={formik.values.forgotPasswordEmail}
              onChange={formik.handleChange}
              maxLength="50"
              onBlur={formik.handleBlur}
              error={
                formik.touched.forgotPasswordEmail &&
                formik.errors.forgotPasswordEmail
              }
              errorMessage={formik.errors.forgotPasswordEmail}
              required={true}
            />
            <div className="signup-options">
              <Button
                label={"Send Email"}
                event={formik.handleSubmit}
                backgroundColor="#6860EE"
                width="100%"
                disabled={isLoading}
              />
            </div>
          </div>
          <div className="forgot-signup-text" style={{ color: "#727277" }}>
            Remember your password?{" "}
            <span
              className="signup-text-span"
              onClick={handleLogin}
              style={{ color: "#6866ee" }}
            >
              Login
            </span>
            <span>
              <img
                className="forgot-signup-text"
                alt="anchor Icon"
                src={SignUpIcon}
                style={{ width: "20px", height: "20px", marginTop: "2px" }}
              ></img>
            </span>
          </div>
          {/* <div className="signup-text">
            New to VybogTAL? <span className="signup-text-span" onClick={handleSignupPage} style={{ color : '#6866ee'}}>Sign Up</span>
            <span>
              <img
                alt="anchor Icon"
                src={SignUpIcon}
                style={{ width: "20px", height: "20px",marginTop: "2px" }}
              />
            </span>
          </div> */}
        </div>
      </div>

      {isDesktop && (
        <div className="signup-background">
          <img
            alt="background"
            src={backgroundImage}
            className="bg-image"
          ></img>
          <div className="background-text">
            Specialized job-matching algorithms
          </div>
          <img alt="slider" src={sliderDots} className="slider-dots"></img>
        </div>
      )}
    </div>
  );
}

export default ForgotPassword;
